import { Stack, Container, Typography, Card } from '@mui/material';
import { LoginForm } from '../sections/authentication/login';
import { RootStyle } from '../components/RootStyle';
import { ContentStyle } from '../components/ContentStyle';

const Login = () => {
  return (
    <RootStyle title='Login'>
      <Container maxWidth='sm'>
        <ContentStyle>
          <Card
            sx={{
              p: { xs: '30px 20px 40px 20px', sm: '30px 30px 40px 30px' },
              boxShadow: 'rgba(100, 100, 111, 0.2) 0px 7px 29px 0px',
            }}
          >
            <Stack
              sx={{ mb: 2 }}
              justifyContent={'center'}
              flexDirection={'row'}
            >
              <Typography
                variant='h4'
                gutterBottom
                color={'primary'}
              >
                Hi, Welcome back
              </Typography>
            </Stack>

            <Stack
              sx={{ mb: 1 }}
              justifyContent={'center'}
              flexDirection={'row'}
            >
              <Typography
                variant='subtitle2'
                gutterBottom
                color={'#637381'}
                sx={{ fontSize: '0.99rem' }}
              >
                Sign in with Whatsapp Number
              </Typography>
            </Stack>
            <LoginForm />
          </Card>
        </ContentStyle>
      </Container>
    </RootStyle>
  );
};
export default Login;
